import { styled } from '@mui/material/styles';
import { OcrWordRoot } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/PageOcrLayer/OcrWords/OcrWord/StyledComponents';

export const OcrWordsSelectionBoxRoot = styled(OcrWordRoot, { label: 'OcrWordsSelectionBoxRoot' })(() => ({
  opacity: 1,
  borderStyle: 'dashed',
}));
